function setupPagination() {
    // Get the data we exposed from the model
    const pagination = window.paginationData;
    const container = document.getElementById("paging-control");
    const rangeDisplay = document.getElementById("pagination-range");

    // pagingItems is emitted html-encoded, and entities are not decoded inside a
    // script block, so &amp; and &#NNNN; would otherwise reach the browser verbatim.
    function decodeUrl(url) {
        if (!url || url.indexOf('&') === -1) return url;
        const decoder = document.createElement('textarea');
        decoder.innerHTML = url;
        return decoder.value;
    }

    if (!container || !pagination || pagination.totalPages <= 1) return;

    // Update the "Showing X-Y of Z" text
    function updateRangeText() {
        const from = ((pagination.currentPage - 1) * pagination.pageSize) + 1;
        const to = Math.min(pagination.currentPage * pagination.pageSize, pagination.totalItems);
        rangeDisplay.innerHTML = `<bdi>${from} - ${to}</bdi> <bdi>${pagination.ofText}</bdi> <bdi>${pagination.totalItems}</bdi> <bdi>${pagination.recordsText}</bdi>`;
    }

    // Determine how many buttons to show based on screen width
    function getMaxButtons() {
        const width = window.innerWidth;
        if (width < 576) return 5;  // Mobile
        if (width < 992) return 7;  // Tablet
        return 9;                   // Desktop
    }

    // Build the pagination controls
    function buildPagination() {
        container.innerHTML = '';
        const maxButtons = getMaxButtons();
        const { currentPage, totalPages, pagingItems, addHref } = pagination;

        // Create Previous button
        const prevBtn = document.createElement('a');
        prevBtn.className = 'prev page-number' + (currentPage === 1 ? ' disabled' : '');
        if (addHref) {
            prevBtn.href = currentPage > 1 ? decodeUrl(pagingItems[currentPage - 1]) : "#";
        }
        prevBtn.innerHTML = '<i class="ci-pazar-small ci-caret-left"></i>';
        prevBtn.setAttribute('page-no', currentPage > 1 ? currentPage - 1 : 0)
        container.appendChild(prevBtn);

        // Always show first page
        createPageButton(1);

        // Calculate window around current page
        const halfWindow = Math.floor((maxButtons - 3) / 2); // -3 for first, last, and current
        let start = Math.max(2, currentPage - halfWindow);
        let end = Math.min(totalPages - 1, currentPage + halfWindow);

        // Adjust if we're near the start or end
        if (currentPage <= halfWindow + 1) {
            end = Math.min(maxButtons - 1, totalPages - 1);
        }
        if (currentPage >= totalPages - halfWindow) {
            start = Math.max(2, totalPages - maxButtons + 2);
        }

        // Add left ellipsis if needed
        if (start > 2) {
            container.appendChild(createEllipsis());
        }

        // Add pages in the calculated window
        for (let i = start; i <= end; i++) {
            createPageButton(i);
        }

        // Add right ellipsis if needed
        if (end < totalPages - 1) {
            container.appendChild(createEllipsis());
        }

        // Always show last page if different from first
        if (totalPages > 1) {
            createPageButton(totalPages);
        }

        // Create Next button
        const nextBtn = document.createElement('a');
        nextBtn.className = 'next page-number' + (currentPage === totalPages ? ' disabled' : '');
        nextBtn.innerHTML = '<i class="ci-pazar-small ci-caret-right"></i>';
        if (addHref) {
            nextBtn.href = currentPage < totalPages ? decodeUrl(pagingItems[currentPage + 1]) : "#";
        }
        nextBtn.setAttribute('page-no', currentPage < totalPages ? currentPage + 1 : "")
        container.appendChild(nextBtn);
    }

    function createPageButton(pageNum) {
        const { pagingItems, addHref } = pagination;
        const btn = document.createElement('a');
        btn.className = 'page-number' + (pageNum === pagination.currentPage ? ' active' : '');
        btn.textContent = pageNum;
        btn.setAttribute('page-no', pageNum);
        if (addHref) {
            btn.href = decodeUrl(pagingItems[pageNum]);
        }
        container.appendChild(btn);
        return btn;
    }

    function createEllipsis() {
        const ellipsis = document.createElement('div');
        ellipsis.className = 'divider';
        ellipsis.textContent = '...';
        return ellipsis;
    }

    // Initialize
    updateRangeText();
    buildPagination();

    container.classList.remove('hidden');

    window.addEventListener('resize', () => {
        updateRangeText();
        buildPagination();
    });
}

document.addEventListener("DOMContentLoaded", setupPagination);

window.setupPagination = setupPagination;
